import React, { Component } from "react";
import t from "babel-plugin-yate/macro";
import { connect } from "react-redux";
import { get } from "lodash-es";
import { Redirect, Link } from "react-router-dom";
import { Form, Field } from "react-final-form";

import {
  isRequired,
  composeFormValidators,
  hasMinLength,
  hasMaxLength,
} from "../lib/validations";
import { resetPassword, changePassword } from "../store/auth/index";
import logo from "../assets/credex-logo-1.svg";
import { Input } from "../components/Form/Input";
import Button from "../components/Button";

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPasswordResetRequestSent: false,
      isPasswordUpdated: false,
    };
  }

  handleResetPasswordRequest = async (payload) => {
    const { resetPassword } = this.props;

    const request = await resetPassword(payload);

    if (!request.error) {
      this.setState({
        isPasswordResetRequestSent: true,
      });
    }
  };

  handlePasswordUpdateSubmit = async (payload) => {
    const { changePassword, match } = this.props;

    const request = await changePassword({
      ...payload,
      token: match.params.passwordUpdateToken,
    });

    if (request.ok) {
      this.setState({
        isPasswordUpdated: true,
      });
    }
  };

  // TODO: Needs rewrite
  returnContent = () => {
    const { match } = this.props;
    const { isPasswordResetRequestSent, isPasswordUpdated } = this.state;

    if (isPasswordResetRequestSent) {
      return (
        <p className="text-center">{t`Check you email for instructions`}.</p>
      );
    }

    if (isPasswordUpdated) {
      return (
        <p className="text-center">
          {t`Your new password has been set`}.<br />
          {t`You can now authenticate`} <Link to="/login">{t`here`}</Link>.
        </p>
      );
    }

    if (!isPasswordUpdated && match.params.passwordUpdateToken) {
      return (
        <Form
          onSubmit={this.handlePasswordUpdateSubmit}
          render={({ handleSubmit }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="pb-5">
                  <Field
                    autoComplete="off"
                    name="new_password"
                    label={t`New Password`}
                    component={Input}
                    type="password"
                    validate={composeFormValidators(
                      isRequired(),
                      hasMinLength(8),
                      hasMaxLength(64),
                    )}
                  />
                </div>

                <div className="pb-5">
                  <Field
                    autoComplete="off"
                    name="new_password_confirmation"
                    label={t`Confirm Pasword`}
                    component={Input}
                    type="password"
                    validate={composeFormValidators(
                      isRequired(),
                      hasMinLength(8),
                      hasMaxLength(64),
                    )}
                  />
                </div>

                <Button
                  title={t`Set new password`}
                  color="purple"
                  fullWidth
                  customProps={{
                    type: "submit",
                  }}
                />
              </form>
            );
          }}
        />
      );
    }

    return (
      <Form
        onSubmit={this.handleResetPasswordRequest}
        render={({ handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <div className="pb-5">
                <Field
                  autoComplete="off"
                  name="username"
                  label={t`Username`}
                  component={Input}
                  validate={isRequired()}
                />
              </div>

              <Button
                title={t`Send request`}
                color="purple"
                fullWidth
                customProps={{
                  type: "submit",
                }}
              />
            </form>
          );
        }}
      />
    );
  };

  render() {
    const { loggedIn, location } = this.props;

    if (loggedIn) return <Redirect to={get(location, "state.redirect", "/")} />;

    return (
      <div style={{ height: "calc(100vh - 45px)" }}>
        <div className="h-full flex flex-col justify-center items-center">
          <div className="w-1/2 border rounded mx-auto">
            <img
              style={{ marginTop: "-45px" }}
              className="mx-auto"
              src={logo}
              alt="Credex"
              width="141"
              height="40"
            />

            <h1 className="text-center text-20 mt-8 mb-8 font-normal">{t`Forgot password`}</h1>
            <div className="p-8 bg-white border-t">{this.returnContent()}</div>
          </div>

          <div className="w-1/2 ml-auto mr-auto text-right mt-4 mb-4">
            <Link
              className={`cursor-pointer hover-text-purple-menu no-underline leading-loose text-grey-darker-1`}
              to="/login"
            >
              {`${t`Back to login`}`}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    loggedIn: state.auth.loggedIn,
  }),
  {
    resetPassword,
    changePassword,
  },
)(ForgotPasswordPage);
